import { render } from "./AddReglementGroupe.vue?vue&type=template&id=e7fbc84c&scoped=true&ts=true"
import script from "./AddReglementGroupe.vue?vue&type=script&lang=ts"
export * from "./AddReglementGroupe.vue?vue&type=script&lang=ts"

import "./AddReglementGroupe.vue?vue&type=style&index=0&id=e7fbc84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7fbc84c"]])

export default __exports__